import { useAppDispatch, useAppSelector } from "@/services/store";
import * as React from "react";
import { MenuOption, selectMenu, setOpen } from "./menu-slice";

export const useSelectedMenu = (): [MenuOption | null, (option: MenuOption | null) => void] => {
  const dispatch = useAppDispatch();
  const selected = useAppSelector(state => state.menu.selected);
  const setSelected = (option: MenuOption | null) => dispatch(selectMenu(option));
  return [selected, setSelected];
};

/**
 * Hook to set or get the open state of the menu
 * if no value is provided in the setter it will act as a toggle.
 */
export const useIsMenuOpen = (): [boolean, (newState?: boolean) => void] => {
  const dispatch = useAppDispatch();
  const open = useAppSelector(state => state.menu.open);
  const setOpenFn = React.useCallback(
    (newState?: boolean) => {
      dispatch(setOpen(newState));
    },
    [dispatch],
  );
  return [open, setOpenFn];
};
